module.exports = __webpack_public_path__ + "static/media/Slide-03.0c0ff6c3.jpg";